import React from 'react';
import HonorCardSelectForm from './ehonor-card-select-form';
import WVForm from './form';

export default class HonorCardSelect extends React.Component {
	constructor(props) {
    	super(props);
	}

	render() {
		return (
			<div className="ehonor-card-form">
				{ this.props.successMessage }
				<WVForm {...this.props} innerForm={HonorCardSelectForm}></WVForm>
			</div>
		);
	}
}